import { useTranslations } from '@vocab/react';
import {
  Heading,
  Loader,
  Rating,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';

import { type CompanyProfileRating, formatRating } from '@seek/libs-shared';
import translations from './.vocab';

type RatingSummaryModel = CompanyProfileRating;

interface Props {
  loading?: boolean;
  model?: RatingSummaryModel;
}

export const RatingSummary = ({ model, loading }: Props) => {
  const { t } = useTranslations(translations);
  if (loading || !model) {
    return <Loader />;
  }
  const value = model.average;
  const numberOfReviews = model.count;
  return (
    <Stack space="medium" align="center">
      <Heading level="1" component="span">
        {formatRating(value, 1)}
      </Heading>
      <Rating rating={value} variant="starsOnly" size="large" />
      <Text size="small">
        <Strong>{numberOfReviews}</Strong> {t('ratings in total')}
      </Text>
    </Stack>
  );
};
